import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import '../cards/category_card.scss';

function CategoryCard({
    category,
    description,
    onEdit,
    onDelete
}) {
    return (
        <Card className="category-card" variant="outlined">
            <CardContent>
                <Typography variant="h5" component="h2">
                    {category}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                    {description}
                </Typography>
                <div className="button-container">
                    <IconButton onClick={onEdit} aria-label="edit" className="edit-button">
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={onDelete} aria-label="delete" className="delete-button">
                        <DeleteIcon />
                    </IconButton>
                </div>
            </CardContent>
        </Card>
    );
}

export default CategoryCard;
